import { ComboModel } from 'app/shared/components/combo/combo-model';
import { HighlightType } from 'app/shared/enums/highlight-type.enum';
import { PickerState } from '../../../../states/picker-state';

export class PickerDialogModel {
  declare public combo2DefaultValue: ComboModel | null;
  declare public combo2DisableFlag: boolean;
  declare public combo2MatLabel: string;
  declare public combo2NullableOption: string;
  declare public combo2Options: ComboModel[] | null;
  declare public comboDefaultValue: ComboModel | null;
  declare public comboDisableFlag: boolean;
  declare public comboMatLabel: string;
  declare public comboNullableOption: string;
  declare public comboOptions: ComboModel[];
  public disableCreationFlag = false;
  declare public elementCreationIcon: string;
  declare public elementCreationLink: string;
  declare public elementCreationLinkLabel: string | null;
  declare public elementCreationMessage: string;
  declare public existenceFlag: boolean;
  declare public highlightCol1GroupFlag: boolean;
  public highlightCol1GroupType: HighlightType = HighlightType.String;
  declare public highlightCol1InfoFlag: boolean;
  declare public highlightCol1LabelFlag: boolean;
  declare public highlightCol1SubgroupFlag: boolean;
  declare public highlightCol2GroupFlag: boolean;
  public highlightCol2GroupType: HighlightType = HighlightType.String;
  declare public highlightCol2InfoFlag: boolean;
  declare public highlightCol2LabelFlag: boolean;
  declare public highlightCol2SubgroupFlag: boolean;
  declare public highlightCol3LabelFlag: boolean;
  public highlightCol3LabelType: HighlightType = HighlightType.String;
  declare public multipleSelectionFlag: boolean;
  declare public state: PickerState;
  public textFilter2Flag = false;
  declare public textFilter2MatLabel: string;
  declare public textFilter2Maxlength: number;
  declare public textFilterMatLabel: string;
  declare public textFilterMaxlength: number;
  declare public titleLabel: string;
  declare public truncatedContentWidth: string;
  declare public unpinnedByDefaultFlag: boolean;
}
